import { ChangeEvent, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { AppTextField, FormCore } from "src/Pages/components";

import { UseBalancesHome } from "../CardsBalances/Hooks/UseBalancesHome";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { IFilterHome } from "src/Contexts/Metrics/ContextMetricsTypes";
import { UseCardInstallments } from "../CardInstallments/Hooks/UseCardInstallments";
import { UseTopProducer } from "../TopsProducers/Hooks/UseTopProducer";
import { UseBalancePiesADM } from "../GraphicPie/GraphicPieCore/Hooks/UseBalancePiesADM";
import { UseBalancePiesOperadora } from "../GraphicPie/GraphicPieCore/Hooks/UseBalancePiesOperadora";
import { UseBalancePiesModalidade } from "../GraphicPie/GraphicPieCore/Hooks/UseBalancePiesModalidade";
import { useHttpRankingCorretores } from "../TableRankingCorretores/Hooks/useHttpRankingCorretores";

export const FormFilterHome = () => {
  const { filterHome, setFilterHome } = useMetricsContext();

  const { handleSubmit: submitBalancesHome } = UseBalancesHome();
  const { handleSubmit: submitCardInstallments } = UseCardInstallments();
  const { handleSubmit: submitTopProducer } = UseTopProducer();
  const { handleSubmit: submitBalancePiesADM } = UseBalancePiesADM();
  const { handleSubmit: submitBalancePiesOperadora } = UseBalancePiesOperadora();
  const { handleSubmit: submitBalancePiesModalidade } = UseBalancePiesModalidade();
  const { handleSubmit: submitBalancePiesCorretor } = UseTopProducer();
  const { handleSubmit: submitRankingCorretores } = useHttpRankingCorretores();

  const [loading, setLoading] = useState(false);

  const handleChange =
    (prop: keyof IFilterHome) => (event: ChangeEvent<HTMLInputElement>) => {
      setFilterHome((prevValue) => ({
        ...prevValue,
        [prop]: event.target.value,
      }));
    };

  const handles = () => {
    setLoading(true);
    submitBalancesHome();
    submitCardInstallments();
    submitTopProducer();
    submitBalancePiesADM();
    submitBalancePiesOperadora();
    submitBalancePiesModalidade();
    submitBalancePiesCorretor();
    submitRankingCorretores();
  };

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [loading]);

  useEffect(() => {
    handles();
  }, []);

  return (
    <FormCore
      isNotCancel
      handleSubmit={handles}
      marginTopButtons="0px"
      sxStyle={{
        margin: "0",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        marginTop: { xs: "8px", md: "0px" },
      }}
      titleSubmit="Filtrar"
      loadingSubmit={loading}
    >
      {/* <Box>
        <AppTextField
          label="Tipo de contrato"
          sxStyle={{
            width: "130px",
            opacity: "",
            pointerEvents: "auto",
            margin: { xs: "2px", sm: "4px 6px" },
          }}
          value={filterHome?.tipo_contrato}
          variant="outlined"
          select
          onChange={handleChange("tipo_contrato")}
        >
          <MenuItem value="ALL">Todos</MenuItem>
          <MenuItem value="PF">PF</MenuItem>
          <MenuItem value="PJ">PJ</MenuItem>
        </AppTextField>
      </Box> */}
      <Box>
        <AppTextField
          label="Inicio *"
          sxStyle={{
            width: "150px",
            opacity: "",
            pointerEvents: "auto",
            margin: { xs: "2px", sm: "4px 6px" },
          }}
          type="date"
          value={filterHome?.startDate}
          variant="outlined"
          onChange={handleChange("startDate")}
        />
        <AppTextField
          label="Final *"
          sxStyle={{
            width: "150px",
            opacity: "",
            pointerEvents: "auto",
            margin: { xs: "2px", sm: "4px 6px" },
          }}
          type="date"
          value={filterHome?.endDate}
          variant="outlined"
          onChange={handleChange("endDate")}
        />
      </Box>
    </FormCore>
  );
};
